<script setup>

const props = defineProps({
  name: {
    type: String,
  },
	surname: {
    type: String,
  },
	title: {
    type: String,
  },
  jobTitle: {
    type: String,
  },
  email: {
    type: String,
  },
	phone: {
    type: String,
  },
	image: {
		type: Object
	},
	color: {
		type: String,
		default: 'red'
	}
})

</script>

<template>
	<div>
		<div v-if="image?.url" class="mb-6 xl:mb-6 aspect-square w-full bg-cover bg-no-repeat bg-center" :style="{ backgroundImage: `url(${image.url})` }"></div>
		<div v-if="title" class="text-2xl fvs600 tracking-[-0.36px] mb-4" :class="`text-${color}`">{{ title }}</div>
		<div v-if="jobTitle" class="text-lg xl:text-2xl font-normal leading-[130%] tracking-[-0.36px] mb-4 dark:text-light text-dark">{{ jobTitle }}</div>
		<div v-if="email" class="dark:text-light text-dark leading-[140%] text-base xl:text-lg mb-1">
			<div>E-mail: <a :href="`mailto:${email}`" class="link" target="_blank">{{ email }}</a></div>
		</div>
		<div v-if="phone" class="dark:text-light text-dark leading-[140%] text-base xl:text-lg">
			<div>Tel.: <a :href="`tel:${phone}`" class="link" target="_blank">{{ phone }}</a></div>
		</div>
	</div>
</template>